import __var_0__ from '@stdlib/vendor/events.js';
import __var_1__ from '@stdlib/vendor/debug.js';
import __var_2__ from '@stdlib/utils/define-property';
import __var_3__ from '@stdlib/utils/define-read-only-property';
import __var_4__ from '@stdlib/utils/keys';
import __var_5__ from '@stdlib/utils/copy';
import __var_6__ from '@stdlib/utils/merge';
import __var_7__ from '@stdlib/assert/is-plain-object';
import __var_8__ from './accessors/is_defined.js';
import __var_9__ from './defaults.json';
import __var_10__ from './props/x/set.js';
import __var_11__ from './props/x/get.js';
import __var_12__ from './props/y/set.js';
import __var_13__ from './props/y/get.js';
import __var_14__ from './props/x-scale/set.js';
import __var_15__ from './props/x-scale/get.js';
import __var_16__ from './props/y-scale/set.js';
import __var_17__ from './props/y-scale/get.js';
import __var_18__ from './props/is-defined/set.js';
import __var_19__ from './props/is-defined/get.js';
import __var_20__ from './props/color/set.js';
import __var_21__ from './props/color/get.js';
import __var_22__ from './props/label/set.js';
import __var_23__ from './props/label/get.js';
import __var_24__ from './props/opacity/set.js';
import __var_25__ from './props/opacity/get.js';
import __var_26__ from './props/width/set.js';
import __var_27__ from './props/width/get.js';
import __var_28__ from './props/style/set.js';
import __var_29__ from './props/style/get.js';
import __var_30__ from './props/auto-render/set.js';
import __var_31__ from './props/auto-render/get.js';
import __var_32__ from './props/line/get.js';
import __var_33__ from './props/x-pos/get.js';
import __var_34__ from './props/y-pos/get.js';
import __var_35__ from './render/index.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// TODO: improve JSDoc examples

// MODULES //
var EventEmitter = __var_0__.EventEmitter;
var logger = __var_1__;
import {scaleLinear as linear} from '@stdlib/vendor/d3-scale.js'; // TODO: remove
var defineProperty = __var_2__;
var setReadOnly = __var_3__;
var objectKeys = __var_4__;
var copy = __var_5__;
var merge = __var_6__;
var isObject = __var_7__;
var isDefined = __var_8__;
var defaults = __var_9__;
var setX = __var_10__;
var getX = __var_11__;
var setY = __var_12__;
var getY = __var_13__;
var setXScale = __var_14__;
var getXScale = __var_15__;
var setYScale = __var_16__;
var getYScale = __var_17__;
var setIsDefined = __var_18__;
var getIsDefined = __var_19__;
var setColor = __var_20__;
var getColor = __var_21__;
var setLabel = __var_22__;
var getLabel = __var_23__;
var setOpacity = __var_24__;
var getOpacity = __var_25__;
var setWidth = __var_26__;
var getWidth = __var_27__;
var setStyle = __var_28__;
var getStyle = __var_29__;
var setAutoRender = __var_30__;
var getAutoRender = __var_31__;
var getLine = __var_32__;
var getXPos = __var_33__;
var getYPos = __var_34__;
var render = __var_35__;


// VARIABLES //

var debug = logger( 'path:main' );
var PRIVATE_PROPS = [
	'_autoRender',
	'_color',
	'_isDefined',
	'_label',
	'_opacity',
	'_style',
	'_width',
	'_xData',
	'_xScale',
	'_yData',
	'_yScale'
];


// MAIN //

/**
* Path constructor.
*
* @constructor
* @param {Options} [options] - constructor options
* @param {ArrayLike} [options.x=[]] - x-values
* @param {ArrayLike} [options.y=[]] - y-values
* @param {Function} [options.xScale] - x scale function
* @param {Function} [options.yScale] - y scale function
* @param {Function} [options.isDefined] - accessor indicating whether a datum is defined
* @param {string} [options.color] - color
* @param {string} [options.label] - label
* @param {NonNegativeInteger} [options.width=2] - width
* @param {number} [options.opacity=0.9] - opacity
* @param {string} [options.style='-'] - style
* @param {boolean} [options.autoRender=false] - indicates whether to re-render on a change event
* @throws {TypeError} must provide valid options
* @returns {Path} Path instance
*
* @example
* var path = new Path({
*     'x': [0.1,0.2,0.3],
*     'y': [0.4,0.5,0.6]
* });
*/
function Path( options ) {
	var self;
	var keys;
	var opts;
	var key;
	var i;
	if ( !( this instanceof Path ) ) {
		if ( arguments.length ) {
			return new Path( options );
		}
		return new Path();
	}
	self = this;

	opts = copy( defaults );
	opts.isDefined = isDefined;
	opts.xScale = linear();
	opts.yScale = linear();

	if ( arguments.length ) {
		if ( !isObject( options ) ) {
			throw new TypeError( 'invalid argument. `options` argument must be an object. Value: `' + options + '`.' );
		}
		opts = merge( opts, options );
	}
	debug( 'Creating an instance with the following configuration: %s.', JSON.stringify( opts ) );
	EventEmitter.call( this );

	for ( i = 0; i < PRIVATE_PROPS.length; i++ ) {
		defineProperty( this, PRIVATE_PROPS[i], {
			'configurable': false,
			'enumerable': false,
			'writable': true,
			'value': null
		});
	}
	// Set options...
	keys = objectKeys( opts );
	for ( i = 0; i < keys.length; i++ ) {
		key = keys[ i ];
		this[ key ] = opts[ key ];
	}

	this.on( 'change', onChange );
	this.on( '_render', onRender );

	return this;

	/**
	* Callback invoked upon receiving a change event.
	*
	* @private
	*/
	function onChange() {
		debug( 'Received a change event.' );
		if ( self._autoRender ) { // eslint-disable-line no-underscore-dangle
			self.render();
		}
	}

	/**
	* Re-emits a render event.
	*
	* @private
	*/
	function onRender() {
		var args;
		var i;
		debug( 'Received a render event. Re-emitting...' );
		args = new Array( arguments.length+1 );
		args[ 0 ] = 'render';
		for ( i = 0; i < arguments.length; i++ ) {
			args[ i+1 ] = arguments[ i ];
		}
		self.emit.apply( self, args );
	}
}

/*
* Create a prototype which inherits from the parent prototype.
*/
Path.prototype = Object.create( EventEmitter.prototype );

/*
* Set the constructor.
*/
Path.prototype.constructor = Path;

/**
* `x` values.
*
* @name x
* @memberof Path.prototype
* @type {ArrayLike}
* @throws {TypeError} must be array-like
* @default []
*
* @example
* var path = new Path({
*     'x': [0.1,0.2,0.3]
* });
*
* var x = path.x;
* // returns [0.1,0.2,0.3]
*/
defineProperty( Path.prototype, 'x', {
	'configurable': false,
	'enumerable': true,
	'set': setX,
	'get': getX
});

/**
* `y` values.
*
* @name y
* @memberof Path.prototype
* @type {ArrayLike}
* @throws {TypeError} must be array-like
* @default []
*
* @example
* var path = new Path({
*     'y': [0.4,0.5,0.6]
* });
*
* var y = path.y;
* // returns [0.4,0.5,0.6]
*/
defineProperty( Path.prototype, 'y', {
	'configurable': false,
	'enumerable': true,
	'set': setY,
	'get': getY
});

/**
* `x` scale function.
*
* @name xScale
* @memberof Path.prototype
* @type {Function}
* @throws {TypeError} must be a function
*
* @example
* var path = new Path({
*     'xScale': function scale(){}
* });
*
* var f = path.xScale;
* // returns <Function>
*/
defineProperty( Path.prototype, 'xScale', {
	'configurable': false,
	'enumerable': true,
	'set': setXScale,
	'get': getXScale
});

/**
* `y` scale function.
*
* @name yScale
* @memberof Path.prototype
* @type {Function}
* @throws {TypeError} must be a function
*
* @example
* var path = new Path({
*     'yScale': function scale(){}
* });
*
* var f = path.yScale;
* // returns <Function>
*/
defineProperty( Path.prototype, 'yScale', {
	'configurable': false,
	'enumerable': true,
	'set': setYScale,
	'get': getYScale
});

/**
* Accessor which defines whether a datum is defined. This accessor is used to define how missing values are encoded. The default behavior is to ignore values which are `NaN`.
*
* @name isDefined
* @memberof Path.prototype
* @type {Function}
* @throws {TypeError} must be a function
*
* @example
* var path = new Path();
* path.isDefined = function isDefined( d ) {
*     // Check for `NaN`:
*     return ( d === d );
* }
*
* @example
* function isDefined( d ) {
*     // Check for `NaN`:
*     return ( d === d );
* }
* var path = new Path({
*     'isDefined': isDefined
* });
* var fcn = path.isDefined;
* // returns <Function>
*/
defineProperty( Path.prototype, 'isDefined', {
	'configurable': false,
	'enumerable': true,
	'set': setIsDefined,
	'get': getIsDefined
});

/**
* Path color.
*
* @name color
* @memberof Path.prototype
* @type {string}
* @throws {TypeError} must be a primitive string
*
* @example
* var path = new Path({
*     'color': 'steelblue'
* });
*
* var color = path.color;
* // returns 'steelblue'
*/
defineProperty( Path.prototype, 'color', {
	'configurable': false,
	'enumerable': true,
	'set': setColor,
	'get': getColor
});

/**
* Path label.
*
* @name label
* @memberof Path.prototype
* @type {string}
* @throws {TypeError} must be a primitive string
*
* @example
* var path = new Path({
*     'label': 'line-1'
* });
*
* var label = path.label;
* // returns 'line-1'
*/
defineProperty( Path.prototype, 'label', {
	'configurable': false,
	'enumerable': true,
	'set': setLabel,
	'get': getLabel
});

/**
* Path opacity.
*
* @name opacity
* @memberof Path.prototype
* @type {number}
* @throws {TypeError} must be a number
* @throws {RangeError} must be a number on the interval `[0,1]`
* @default 0.9
*
* @example
* var path = new Path({
*     'opacity': 0.5
* });
*
* var opacity = path.opacity;
* // returns 0.5
*/
defineProperty( Path.prototype, 'opacity', {
	'configurable': false,
	'enumerable': true,
	'set': setOpacity,
	'get': getOpacity
});

/**
* Path width.
*
* @name width
* @memberof Path.prototype
* @type {NonNegativeInteger}
* @throws {TypeError} must be a nonnegative integer
* @default 2
*
* @example
* var path = new Path({
*     'width': 1
* });
*
* var width = path.width;
* // returns 1
*/
defineProperty( Path.prototype, 'width', {
	'configurable': false,
	'enumerable': true,
	'set': setWidth,
	'get': getWidth
});

/**
* Path style.
*
* @name style
* @memberof Path.prototype
* @type {string}
* @throws {TypeError} must be a string primitive
* @default '-'
*
* @example
* var path = new Path({
*     'style': '-.'
* });
*
* var style = path.style;
* // returns '-.'
*/
defineProperty( Path.prototype, 'style', {
	'configurable': false,
	'enumerable': true,
	'set': setStyle,
	'get': getStyle
});

/**
* Rendering mode. If `true`, an instance re-renders on each change event.
*
* @name autoRender
* @memberof Path.prototype
* @type {boolean}
* @throws {TypeError} must be a boolean primitive
* @default false
*
* @example
* var path = new Path({
*     'autoRender': true
* });
*
* var mode = path.autoRender;
* // returns true
*/
defineProperty( Path.prototype, 'autoRender', {
	'configurable': false,
	'enumerable': true,
	'set': setAutoRender,
	'get': getAutoRender
});

/**
* Returns a function to generate a line as an SVG path.
*
* @name line
* @memberof Path.prototype
* @type {Function}
*
* @example
* var path = new Path();
*
* var line = path.line;
* // returns <Function>
*/
defineProperty( Path.prototype, 'line', {
	'configurable': false,
	'enumerable': true,
	'get': getLine
});

/**
* Function to map values to x coordinate values.
*
* @name xPos
* @memberof Path.prototype
* @type {Function}
*
* @example
* var path = new Path();
* var xPos = path.xPos;
* // returns <Function>
*/
defineProperty( Path.prototype, 'xPos', {
	'configurable': false,
	'enumerable': true,
	'get': getXPos
});

/**
* Function to map values to y coordinate values.
*
* @name yPos
* @memberof Path.prototype
* @type {Function}
*
* @example
* var path = new Path();
* var yPos = path.yPos;
* // returns <Function>
*/
defineProperty( Path.prototype, 'yPos', {
	'configurable': false,
	'enumerable': true,
	'get': getYPos
});

/**
* Renders a virtual DOM tree.
*
* @name render
* @memberof Path.prototype
* @type {Function}
* @returns {VTree} virtual tree
*
* @example
* var path = new Path();
*
* var out = path.render();
*/
setReadOnly( Path.prototype, 'render', render );


// EXPORTS //
export default Path;
